<template>
    <section class="entries"
        v-if="this.userArtworks.length > 0">
        <Heading :h="3" size="xl">
            <template v-if="preferences.language === 'en'">
                {{ siteContent.moreFrom }}
            </template>
            {{ currentEntry.creator.artist.name }}
            <template v-if="preferences.language === 'hu'">
                {{ siteContent.furtherWorks }}
            </template>
        </Heading>
        <FeedSkeleton class="feedSkeleton"
            v-if="loading"/>
        <EntryFeed
            v-else
            :entries="userArtworks"/>
        <FeedSkeleton class="resetMargin"
            v-if="!userEntriesReachedBottom"
            v-view="handleView"/>
    </section>
</template>

<script>
    import { mapActions, mapState } from 'vuex'

    import EntryFeed from    '@/components/journal/main/EntryFeed'
    import FeedSkeleton from '@/components/layout/main/FeedSkeleton'

    export default {
        name: 'RelatedEntries',
        components: {
            EntryFeed,
            FeedSkeleton
        },
        props: {
            currentEntry: Object
        },
        data() {
            return {
                loading: true
            }
        },
        computed: {
            ...mapState('journal',['userArtworks','userEntriesReachedBottom']),

            lastVisible() {
                return this.userArtworks[this.userArtworks.length - 1]
            }
        },
        async mounted() {
            this.fetchEntries()
        },
        methods: {
            ...mapActions('journal',['fetchEntriesAfter','purgeUserEntries']),

            async fetchEntries() {
                await this.fetchEntriesAfter({
                    commitName:         'addUserArtworks',
                    feedType:           'userEntries',
                    timelinePreference:  this.preferences.timeline,
                    orderPreference:     this.preferences.order,
                    lastVisible:         this.currentEntry,
                    artistID:            this.currentEntry.creator.artist.id,
                    visibility:          true,
                    limit:               2
                })
                this.loading = false
            },
            async handleView(event) {
                if(event.type === 'enter') {
                    await this.fetchEntriesAfter({
                        commitName:         'addUserArtworks',
                        feedType:           'userEntries',
                        timelinePreference:  this.preferences.timeline,
                        orderPreference:     this.preferences.order,
                        lastVisible:         this.lastVisible,
                        artistID:            this.currentEntry.creator.artist.id,
                        visibility:          true,
                        limit:               2
                    })
                }
            }
        },
        watch: {
            // call again the method if the route changes
            '$route.params': {
            handler: function() {
                this.purgeUserEntries()
            },
            deep: true,
            immediate: true
        }
        },
    }
</script>

<style scoped lang="scss">
    @import '../../scss/variables';

    .h3 {
        padding: 3rem 4rem 1rem 4rem;
        margin: 0;
    }

    @media all and (max-width: 1440px) {
        .h3 {
            padding: 3rem 0 1rem 0;
        }
    }
</style>